import { useState, useEffect } from 'react';
import { getWeeklyCheckInStatus } from '../services/api';

export const useWeeklyCheckIn = () => {
  const [weeklyStatus, setWeeklyStatus] = useState<boolean[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchWeeklyStatus = async () => {
      try {
        setIsLoading(true);
        const status = await getWeeklyCheckInStatus();
        setWeeklyStatus(status);
        setError(null);
      } catch (err) {
        setError('Failed to fetch weekly check-in status');
        console.error('Error in useWeeklyCheckIn:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWeeklyStatus();
  }, []);

  return {
    weeklyStatus,
    isLoading,
    error,
    refetch: () => {
      setIsLoading(true);
      getWeeklyCheckInStatus()
        .then(status => {
          setWeeklyStatus(status);
          setError(null);
        })
        .catch(err => {
          setError('Failed to fetch weekly check-in status');
          console.error('Error in useWeeklyCheckIn refetch:', err);
        })
        .finally(() => setIsLoading(false));
    }
  };
}; 